import {
  Baby,
  BookOpen, Cake, CalendarDays, CalendarX, Camera,
  Car,
  Check, Circle, ClipboardList, Clock, Container, File,
  FileText, Folder,
  Fuel, Gift,
  GraduationCap, IdCard, Key, Leaf, Lightbulb, Link, ListChecks,
  type LucideIcon, Navigation, Newspaper,
  PartyPopper, PenLine, ScanHeart,
  Smartphone,
  Smile, SprayCan, ThumbsUp, Timer, Trophy, Type,
  User, Zap
} from "lucide-react";

export const ICON_BY_NAME = {
  person: User,
  carwash: Car,
  smartphone: Smartphone,
  checkmark: Check,
  celebration: PartyPopper,
  smile: Smile,
  training: GraduationCap,
  school: GraduationCap,
  'fuel station': Fuel,
  document: FileText,
  clipboard: ClipboardList,
  gps: Navigation,
  leaf: Leaf,
  eco: Leaf,
  clock: Clock,
  'stylus note': PenLine,
  'quick reference': BookOpen,
  'calendar month': CalendarDays,
  cake: Cake,
  'rewarded ads': Gift,
  mop: SprayCan,
  'thumb up': ThumbsUp,
  checklist: ListChecks,
  container: Container,
  'id card': IdCard,
  'emoji objects': Lightbulb,
  news: Newspaper,
  'escalator warning': Baby,
  'minor crash': Car,
  'photo camera': Camera,
  file: File,
  text: Type,
  url: Link,
  folder: Folder,
  leaderboard: Trophy,
  timetracker: Timer,
  key: Key,
  circle: Circle,
  absence: CalendarX,
  insurance: ScanHeart,
} satisfies Record<string, LucideIcon>

/** All valid icon keys — lets TS check keys at compile time. */
export type IconName = keyof typeof ICON_BY_NAME

/** String-indexable view of ICON_BY_NAME for lookups with arbitrary (e.g. backend) values. */
const ICON_LOOKUP: Record<string, LucideIcon | undefined> = ICON_BY_NAME

export function iconForName(
  iconName: string | null | undefined,
  fallback: LucideIcon = Zap,
): LucideIcon {
  if (!iconName) return fallback
  return ICON_LOOKUP[iconName.trim().toLowerCase()] ?? fallback
}
